import Raven from 'raven-js';

import config from '../../config';

const {
  ENVIRONMENT,
  REACT_APP_SENTRY_API_KEY,
  REACT_APP_SENTRY_PROJECT_ID,
} = config;

if (ENVIRONMENT !== 'development') {
  Raven.config(
    `https://${REACT_APP_SENTRY_API_KEY}@sentry.io/${REACT_APP_SENTRY_PROJECT_ID}`,
    { environment: ENVIRONMENT }
  ).install();
}



// WEBPACK FOOTER //
// ./src/_app/logging/sentry.js